module.exports = __webpack_public_path__ + "static/media/conference.782451e6.svg";